import { useRef } from "react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import UserManagementActions from "../../Actions/UserManagementActions";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import usermanagementStore from "../../Stores/UsermanagementStore";
import commonUtils from "../../helpers/commonUtils";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

const AddOrganizationAdmin = (props) => {
  const { orgList } = props;
  const [firstname, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [support, setSupoort] = useState(false);
  const [plantList, setPlantList] = useState([]);
  const [orgid, setOrganisationId] = useState("");
  const [plantId, setPlantId] = useState("");
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const isSupportRef = useRef(false);

  const getPlants = (id) => {
    setGlobalSpinner(true);
    UserManagementActions.getPlants(id);
  };

  const handleOrganisationChange = (e) => {
    setOrganisationId(e.target.value);
    getPlants(e.target.value);
  };

  const addOrganisationAdmin = (e) => {
    e.preventDefault();
    var data = {
      WerkID: plantId,
      OrganisationId: support
        ? sessionStorage.getItem("organizationID")
        : orgid,
      FirstName: firstname,
      Surname: surname,
      Username: username,
      Email: email,
      IsSupportUser: support,
    };
    setGlobalSpinner(true);
    UserManagementActions.addOrganisationAdmin(data);
  };

  useEffect(() => {
    isSupportRef.current = support;
    if (support) {
      setOrganisationId(sessionStorage.getItem("organizationID"));
      getPlants(sessionStorage.getItem("organizationID"));
    }
  }, [support]);
  /*-----------------------------Add organisation admin section start --------------------------------*/
  useEffect(() => {
    function addOrganisationAdminSuccess() {
      resetFields();
      commonUtils.hideModalPopUp("addOrganisationAdminModalClose");
      toast.success(localization.orgAdminAddedSuccessfully);
      setGlobalSpinner(false);
    }

    function addOrganisationAdminFailure() {
      var res = usermanagementStore.getAddOrganisationAdminResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADD_ORGANISATION_ADMIN_SUCCESS,
      addOrganisationAdminSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.ADD_ORGANISATION_ADMIN_FAILURE,
      addOrganisationAdminFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADD_ORGANISATION_ADMIN_SUCCESS,
        addOrganisationAdminSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.ADD_ORGANISATION_ADMIN_FAILURE,
        addOrganisationAdminFailure,
      );
    };
  }, []);

  /*-----------------------------Add organisation admin section end ----------------------------------*/

  const resetFields = () => {
    setFirstName("");
    setSurname("");
    setUsername("");
    setEmail("");
    setOrganisationId("");
    setPlantId("");
    setSupoort(false);
  };

  useEffect(() => {
    function getPlantSuccess() {
      var res = usermanagementStore.getPlantResult();
      if (res.length > 0) {
        setPlantList(res);
        if (isSupportRef.current) {
          setPlantId(res[0]["id"]);
        }
      } else {
        setPlantList([]);
      }
      setGlobalSpinner(false);
    }

    function getPlantFailure() {
      setGlobalSpinner(false);
    }

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_SUCCESS,
      getPlantSuccess,
    );

    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_FAILURE,
      getPlantFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_SUCCESS,
        getPlantSuccess,
      );

      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_FAILURE,
        getPlantFailure,
      );
    };
  }, [plantList]);

  return (
    <div
      className="modal fade"
      id="addOrganisationAdminModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addOrganisationAdminModal"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addOrganisationAdminModal">
              {localization.addOrganisationAdmin}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addOrganisationAdminModalClose"
              onClick={resetFields}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form
            id="addOrganisationAdmin"
            name="addOrganisationAdmin"
            onSubmit={addOrganisationAdmin}
          >
            <div className="modal-body">
              <div className="row mb-4">
                <div className="col">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="firstName">
                      {localization.firstname}
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      className="form-control"
                      required
                      value={firstname}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="Surname">
                      {localization.surname}
                    </label>
                    <input
                      type="text"
                      id="Surname"
                      className="form-control"
                      required
                      value={surname}
                      onChange={(e) => {
                        setSurname(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="Username">
                  {localization.username}
                </label>
                <input
                  type="text"
                  id="Username"
                  className="form-control"
                  required
                  value={username}
                  onChange={(e) => {
                    setUsername(e.target.value);
                  }}
                />
              </div>

              <div className="form-outline mb-4">
                <label className="form-label" htmlFor="email">
                  {localization.email}
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  required
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                />
              </div>
              <div className="form-group d-flex ">
                <label htmlFor="organizationList">
                  {localization.supportUser}
                </label>
                <input
                  className="ml-2"
                  type="checkBox"
                  id="support"
                  name="support"
                  checked={support}
                  onChange={(e) => {
                    setSupoort((prev) => !prev);
                  }}
                />
              </div>
              <div className="form-group">
                <label htmlFor="organizationList">
                  {localization.organisation}
                </label>
                <select
                  className="form-control"
                  id="organizationList"
                  name="organizationList"
                  required
                  disabled={support}
                  value={orgid}
                  onChange={handleOrganisationChange}
                >
                  <option value="">{localization.selectOrganisation}</option>
                  {orgList?.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {row.name}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="plantList">{localization.loaction}</label>
                <select
                  className="form-control"
                  id="plantList"
                  name="plantList"
                  required
                  disabled={support}
                  value={plantId}
                  onChange={(e) => {
                    setPlantId(e.target.value);
                  }}
                >
                  <option value="">{localization.selectPlant}</option>
                  {plantList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {row.bezeichnung}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp ">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddOrganizationAdmin;
